import React from "react";

const ToastNotifications = ({ submitted, submitError, setSubmitted, setSubmitError }) => {
  return (
    <>
      {submitted && (
        <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 11 }}>
          <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header bg-success text-white">
              <strong className="me-auto">Success</strong>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setSubmitted(false)}
              ></button>
            </div>
            <div className="toast-body">Campaign created successfully!</div>
          </div>
        </div>
      )}
      {submitError && (
        <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 11 }}>
          <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header bg-danger text-white">
              <strong className="me-auto">Error</strong>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setSubmitError("")}
              ></button>
            </div>
            <div className="toast-body">{submitError}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default ToastNotifications;